import Cookies from 'js-cookie';
import { PAP_COOKIE } from '@mm/constants/referrals';

export const extractAffiliateData = () => {
  try {
    const affiliateData =
      Cookies.get(PAP_COOKIE) || localStorage.getItem(PAP_COOKIE);
    if (affiliateData) {
      const [code, visitorId] = affiliateData.split('::');
      return {
        code,
        visitorId,
      };
    }
  } catch {}
  return null;
};
